/* eslint-disable complexity */
import styled from '@emotion/styled';
import { LoadingButton } from '@mui/lab';
import { Autocomplete, Button, DialogTitle, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import useSearchBranch from 'api/branch/useSearchBranch/useSearchBranch';
import useSearchOrigin from 'api/branch/useSearchOrigin/useSearchOrigin';
import useDisplacementOrigin from 'api/productDetail/useDisplacementOrigin/useDisplacementOrigin';
import useGroupDisplacementOrigin from 'api/productDetail/useDisplacementOrigin/useGroupDisplacementOrigin';
import SpinnerLoader from 'components/shared/SpinnerLoader/SpinnerLoader';
import React, { useEffect, useState } from 'react';

const GroupBranchesDisplacementModal = ({
  open,
  branchesGuids,
  refetchDetails,
  handleClose,
}) => {
  const [selectedValue, setSelectedValue] = useState(null);

  const [searchBranches, searchedBranchesLoading, searchedBranches] =
    useSearchOrigin();
  const [groupDisplacement, groupDisplaceLoading] =
    useGroupDisplacementOrigin();

  useEffect(() => {
    searchBranches();
  }, []);

  const submitDisplacement = () => {
    groupDisplacement({ branchesGuids, originGuid: selectedValue?.key }, () =>
      refetchDetails(),
    );
  };

  return (
    <Dialog open={open} onClose={handleClose} sx={{ direction: 'rtl' }}>
      <DialogTitle>انتقال گروهی برنچ‌ها به اورجین جدید</DialogTitle>

      <DialogContent sx={{ width: '400px' }}>
        {searchedBranchesLoading ? (
          <SpinnerLoader />
        ) : (
          <>
            {/* {currentOrigin ? (
              <Typography sx={{ mb: 2 }}>
                اورجین فعلی: {currentOrigin}
              </Typography>
            ) : null} */}

            <FormControl
              sx={{
                'maxWidth': '350px',
                '& *': {
                  textAlign: 'right !important',
                },
              }}
              fullWidth
            >
              <Autocomplete
                dir="ltr"
                options={searchedBranches || []}
                autoHighlight
                value={selectedValue || null}
                getOptionLabel={option => option.value}
                noOptionsText={
                  <div className="w-full flex justify-center">
                    موردی یافت نشد
                  </div>
                }
                renderOption={(args, option) => (
                  <div {...args}>{option.value}</div>
                )}
                onChange={(event, newValue) => {
                  setSelectedValue(newValue);
                }}
                sx={{
                  '.MuiInputBase-root': {
                    paddingRight: '9px !important',
                  },
                  'direction': 'ltr',
                }}
                renderInput={params => (
                  <TextField
                    {...params}
                    sx={{
                      '.MuiAutocomplete-endAdornment': {
                        right: 'unset !important',
                        left: '9px',
                      },
                      '.MuiAutocomplete-endAdornment button': {
                        mr: 0.5,
                      },
                    }}
                    name="displacement-autocomplete"
                    label="اورجین جدید"
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: 'new-password', // disable autocomplete and autofill
                    }}
                    className="gray-icon"
                    InputProps={{
                      ...params.InputProps,
                    }}
                  />
                )}
              />
            </FormControl>
          </>
        )}
      </DialogContent>

      <DialogActions sx={{ gap: 1, padding: 3 }}>
        <Button
          onClick={handleClose}
          variant="contained"
          disabled={groupDisplaceLoading}
        >
          انصراف
        </Button>
        <LoadingButton
          variant="contained"
          color="warning"
          onClick={submitDisplacement}
          loading={groupDisplaceLoading}
        >
          انتقال
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default GroupBranchesDisplacementModal;
